import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../globals';
import { ConfigurationServices } from '../../../../configuration/services';

/**
 * Generated class for the ComboPartialDishesSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-complements-partial-dishes-selected',
    templateUrl: 'complements-partial-dishes-selected.html',
})
export class ComplementsPartialDishesSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public configurationService: ConfigurationServices,
        public translate: TranslateService) {
    }

    deleteElement(index) {
        if (index >= 0) {
            this.configurationService.complements_selected.splice(index, 1);
            this.configurationService.complements_selected = [...this.configurationService.complements_selected];
        }
    }

    reorderElements(indexes) {
        var element = this.configurationService.complements_selected[indexes.from];
        this.configurationService.complements_selected.splice(indexes.from, 1);
        this.configurationService.complements_selected.splice(indexes.to, 0, element);
    }
}



// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-dishes-selected/complements-partial-dishes-selected.ts